<div>
  <label *ngIf="label" [attr.for]="identifier">{{label}}</label>
  <p-autoComplete #primecomplete [(ngModel)]="value" [suggestions]="suggestions" (completeMethod)="completeMethod($event)"
    [dataKey]="dataKey"
    [inputId]="identifier"
    [field]="field || ''"
    [placeholder]="placeholder || ''"
    [inputStyleClass]="multiple ? '' : 'form-control'"
    [dropdown]="dropdown"
    [disabled]="disabled"
    [readonly]="readonly"
    [multiple]="multiple"
    [forceSelection]="forceSelection && !multiple"
    (onClear)="clear($event)"
    (onSelect)="selectMethod($event)"
    (onKeyUp)="keyUpMethod($event)"
  ></p-autoComplete>
  <validation [elementBase]="this"></validation>
</div>



// WEBPACK FOOTER //
// ./src/deps/pmv-common/pmv-common.d.ts.ɵu.html